import type { FC } from 'react';

import { Placeholder, useRendering } from '@eneco/cms';
import {
  NavigationViewFirstItem,
  NavigationViewGrid,
  NavigationViewSecondItem,
} from '@eneco/custom-components/NavigationView';
import { Stack } from '@eneco/sparky';

import { NAVIGATION_VIEW_SLOTS, resolveSlot } from './slots';

/**
 * `NavigationView` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Carries no content of its own — a two-column grid around its two placeholders, mirroring
 * `libs/sitecore/components/content/src/NavigationView/NavigationView.tsx` 1:1. Both grid items render
 * even when their slot is empty, as the legacy markup does, so the second column keeps its position.
 */
const NavigationView: FC = () => {
  const rendering = useRendering();
  const firstSlot = resolveSlot(rendering, NAVIGATION_VIEW_SLOTS.first);
  const secondSlot = resolveSlot(rendering, NAVIGATION_VIEW_SLOTS.second);

  return (
    <NavigationViewGrid
      alignY="stretch"
      columns="12"
      gap={{
        initial: '3',
        lg: '4',
        xl: '6',
      }}>
      <NavigationViewFirstItem
        gridColumn={{
          initial: '1 / -1',
          md: '1 / 3',
        }}>
        {firstSlot ? <Placeholder name={firstSlot} /> : null}
      </NavigationViewFirstItem>
      <NavigationViewSecondItem
        gridColumn={{
          initial: '1 / -1',
          md: '3 / -3',
        }}>
        <Stack gap={{ initial: '10', md: '16' }} direction="column">
          {secondSlot ? <Placeholder name={secondSlot} /> : null}
        </Stack>
      </NavigationViewSecondItem>
    </NavigationViewGrid>
  );
};

export default NavigationView;
